<template>
  <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('机构名称')"
          :hidden="false"
          hasFeedback >
          <a-input :placeholder="$t('请输入机构/部门名称')" v-decorator="['departName', validatorRules.departName ]"/>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :hidden="seen" :label="$t('上级部门')" hasFeedback>
          <a-tree-select
            style="width:100%"
            :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
            :treeData="departTree"
            v-model="model.parentId"
            :placeholder="$t('请选择上级部门')"
            :disabled="condition">
          </a-tree-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('机构类型')">
          <template v-if="seen">
          <a-radio-group v-decorator="['orgCategory',validatorRules.orgCategory]" :placeholder="$t('请选择机构类型')">
            <a-radio value="1">
              {{ $t('公司') }}
            </a-radio>
          </a-radio-group>
          </template>
          <template v-else>
            <a-radio-group v-decorator="['orgCategory',validatorRules.orgCategory]" :placeholder="$t('请选择机构类型')">
              <a-radio value="2">
                {{ $t('部门') }}
              </a-radio>
              <a-radio value="3">
                {{ $t('岗位') }}
              </a-radio>
            </a-radio-group>
          </template>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('电话')">
          <a-input :placeholder="$t('请输入电话')" v-decorator="['mobile',validatorRules.mobile]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('传真')">
          <a-input :placeholder="$t('请输入传真')" v-decorator="['fax', {}]"  />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('地址')">
          <a-input :placeholder="$t('请输入地址')" v-decorator="['address', {}]"  />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('排序')">
          <a-input-number v-decorator="[ 'departOrder',{'initialValue':0}]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('备注')">
          <a-textarea :placeholder="$t('请输入备注')" v-decorator="['memo', {}]"  />
        </a-form-item>
        <template v-if="seen">
          <a-form-item
            v-for="(k, index) in form.getFieldValue('keys')"
            :key="k"
            v-bind="index === 0 ? formItemLayout : formItemLayoutWithOutLabel"
            :label="index === 0 ? $t('应用ID') : ''"
            :required="true"
          >
            <a-input
              v-decorator="[
              `appId${k}`,validatorRules.appId
              /*
              {
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: '请输入应用ID'
                  }
                ]
              },
              */
              ]"
              :placeholder="$t('请输入应用ID')"
              style="width: 60%; margin-right: 8px"
            />
            <a-icon
              v-if="form.getFieldValue('keys').length > 1"
              class="dynamic-delete-button"
              type="minus-circle-o"
              :disabled="form.getFieldValue('keys').length === 1"
              @click="() => removeField(k)"
              style="margin-right:-20px"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayoutWithOutLabel">
            <a-button type="dashed" style="width: 60%" @click="addField">
              <a-icon type="plus" /> Add field
            </a-button>
          </a-form-item>
        </template>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import { queryIdTree } from '@/api/api'
  import pick from 'lodash.pick'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import {isUndefined} from'@/utils/validate'
  let idNumber = 0;
  export default {
    name: "SysDepartModal",
    components: { ATextarea },
    data () {
      return {
        departTree:[],
        orgTypeData:[],
        phoneWarning:'',
        departName:"",
        title:this.$t("操作"),
        seen:false,
        visible: false,
        condition:true,
        disableSubmit:false,
        model: {},
        menuhidden:false,
        menuusing:true,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },

        confirmLoading: false,
        form: this.$form.createForm(this),
        url: {
          add: "/sys/sysDepart/add",
          queryAppIdAndCompanyByAppId: "/jeecg-charge/meter/departAppinfo/list"
        },
        dictDisabled:true,
        formItemLayout: {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
          },
        },
        formItemLayoutWithOutLabel: {
          wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 20, offset: 4 },
          },
        },
      }
    },
    created () {
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      validatorRules(){
        return {
        departName:{rules: [{ required: true, message: this.$t('请输入机构/部门名称!') }]},
        orgCode:{rules: [{ required: true, message: this.$t('请输入机构编码!') }]},
        mobile:{rules: [{validator:this.validateMobile}]},
        appId:{rules: [
          { required: true, message: this.$t('请输入appId!') }
          //,{validator: this.validateAppId}
        ]},
        }
      },
    },
    methods: {
      loadTreeData(){
        var that = this;
        queryIdTree().then((res)=>{
          if(res.success){
            that.departTree = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i];
              that.departTree.push(temp);
            }
          }

        })
      },
      add (depart) {
        if(depart){
          this.seen = false;
          this.dictDisabled = false;
        }else{
          this.seen = true;
          this.dictDisabled = true;
        }
        this.edit(depart);
      },
      edit (record) {
        
          this.form.resetFields();
          idNumber = 0;
          this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
          this.addField();
          this.model = Object.assign({}, record);
          this.visible = true;
          this.loadTreeData();
          this.model.parentId = record !==null?record.toString():null;
          if(this.seen){
            this.model.orgCategory = '1';
          }else{
            this.model.orgCategory = '2';
          }
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'orgCategory','departName','departNameEn','departNameAbbr','departOrder','description','orgType','orgCode','mobile','fax','address','memo','status','delFlag'))
          });
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            let arr = []
            for(let k in formData) {
              if(k.indexOf("appId")>-1) {
                arr.push(formData[k])
                delete formData[k]
              }
            }
            if(arr.length>0) {
              formData.appIds = arr.join(',')
            }
            
            //时间格式化
            console.log(formData)
            httpAction(this.url.add,formData,"post").then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadTreeData();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateMobile(rule,value,callback){
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)){
          callback();
        }else{
          callback(this.$t("您的手机号码格式不正确!"));
        }

      },
      removeField(k) {
        const { form } = this;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');
        // We need at least one passenger
        if (keys.length === 1) {
          return;
        }

        // can use data-binding to set
        form.setFieldsValue({
          keys: keys.filter(key => key !== k),
        });
      },
      addField() {
        const { form } = this;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(idNumber++);
        // can use data-binding to set
        // important! notify form to detect changes
        form.setFieldsValue({
          keys: nextKeys,
        });
      },
      // 查询用户编号是否重复
      validateAppId(rule, value, callback) {
        if(isUndefined(value)||value.replace(/\s+/g,'') == '') {
          callback()
          return
        }
        let params = {appId: value}
        getAction(this.url.queryAppIdAndCompanyByAppId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].departId === this.model.id) {
              callback()
            }else{
              callback(this.$t("该应用ID已被绑定，请验证后重新输入!"))
            }
          } else {
            callback()
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>